<div class="international-address-form-grid" *ngIf="form && !(isLoading$ | async); else loading" [formGroup]="form">
  <div class="grid-cell country-cell d-flex flex-column gap-2">
    <label class="form-input-label" [for]="controlIds.countryId" i18n>Country</label>
    <app-dropdown-input
      formControlName="countryId"
      placeholder=""
      [controlId]="controlIds.countryId"
      [dropdowns]="(countryDropdowns$ | async) ?? []"
      [error]="formSubmitted && form.controls.countryId.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.countryId.invalid"
      [errors]="form.controls.countryId.errors"
      [customErrorMessages]="customErrorMessages.countryId" />
  </div>

  <div class="grid-cell address-line-1-cell d-flex flex-column gap-2">
    <label class="form-input-label" [for]="controlIds.addressLine1" i18n>Address Line 1</label>
    <app-text-input
      formControlName="addressLine1"
      [controlId]="controlIds.addressLine1"
      [error]="formSubmitted && form.controls.addressLine1.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.addressLine1.invalid"
      [errors]="form.controls.addressLine1.errors"
      [customErrorMessages]="customErrorMessages.addressLine1" />
  </div>

  <div class="grid-cell address-line-2-cell d-flex flex-column gap-2">
    <label class="form-input-label" [for]="controlIds.addressLine2" i18n>Address Line 2</label>
    <app-text-input formControlName="addressLine2" [controlId]="controlIds.addressLine2" />
    <div class="form-input-hint" i18n>Optional</div>
  </div>

  <div class="grid-cell address-line-3-cell d-flex flex-column gap-2">
    <label class="form-input-label" [for]="controlIds.addressLine3" i18n>Address Line 3</label>
    <app-text-input formControlName="addressLine3" [controlId]="controlIds.addressLine3" />
    <div class="form-input-hint" i18n>Optional</div>
  </div>

  <div class="grid-cell city-cell d-flex flex-column gap-2">
    <label class="form-input-label" [for]="controlIds.city" i18n>City/Town</label>
    <app-text-input
      formControlName="city"
      [controlId]="controlIds.city"
      [error]="formSubmitted && form.controls.city.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.city.invalid"
      [errors]="form.controls.city.errors"
      [customErrorMessages]="customErrorMessages.city" />
  </div>

  <div class="grid-cell state-cell d-flex flex-column gap-2" *ngIf="!(stateFieldHidden$ | async)">
    <label class="form-input-label" [for]="controlIds.stateId" i18n>Province/State/Region</label>
    <app-dropdown-input
      formControlName="stateId"
      placeholder=""
      [controlId]="controlIds.stateId"
      [dropdowns]="(stateDropdowns$ | async) ?? []"
      [clearable]="(stateAndPostalCodeOptional$ | async) ?? false"
      [error]="formSubmitted && form.controls.stateId.invalid" />
    <app-form-error
      *ngIf="formSubmitted && form.controls.stateId.invalid"
      [errors]="form.controls.stateId.errors"
      [customErrorMessages]="customErrorMessages.stateId" />
    <div class="form-input-hint" *ngIf="stateAndPostalCodeOptional$ | async" i18n>Optional</div>
  </div>

  <div
    class="grid-cell postal-code-cell d-flex flex-column gap-2"
    [class.state-field-hidden]="stateFieldHidden$ | async">
    <label class="form-input-label" [for]="controlIds.postalCode" i18n>Postal Code/ZIP</label>
    <app-masked-text-input
      *ngIf="postalCodeIsMasked$ | async; else plainPostalCode"
      formControlName="postalCode"
      [controlId]="controlIds.postalCode"
      [maskOptions]="postalCodeMaskOptions"
      [error]="formSubmitted && form.controls.postalCode.invalid" />
    <ng-template #plainPostalCode>
      <app-text-input
        formControlName="postalCode"
        [controlId]="controlIds.postalCode"
        [error]="formSubmitted && form.controls.postalCode.invalid" />
    </ng-template>
    <app-form-error
      *ngIf="formSubmitted && form.controls.postalCode.invalid"
      [errors]="form.controls.postalCode.errors"
      [customErrorMessages]="customErrorMessages.postalCode" />
    <div class="form-input-hint" *ngIf="stateAndPostalCodeOptional$ | async" i18n>Optional</div>
  </div>
</div>

<ng-template #loading>
  <div class="international-address-form-grid" aria-busy="true">
    <div class="grid-cell country-cell d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'5rem'" />
      <lib-loading-shimmer [height]="inputShimmerHeight" [width]="'100%'" />
    </div>
    <div class="grid-cell address-line-1-cell d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'7rem'" />
      <lib-loading-shimmer [height]="inputShimmerHeight" [width]="'100%'" />
    </div>
    <div class="grid-cell address-line-2-cell d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'7rem'" />
      <lib-loading-shimmer [height]="inputShimmerHeight" [width]="'100%'" />
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'4rem'" />
    </div>
    <div class="grid-cell address-line-3-cell d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'7rem'" />
      <lib-loading-shimmer [height]="inputShimmerHeight" [width]="'100%'" />
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'4rem'" />
    </div>
    <div class="grid-cell city-cell d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'5rem'" />
      <lib-loading-shimmer [height]="inputShimmerHeight" [width]="'100%'" />
    </div>
    <div class="grid-cell state-cell d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'10rem'" />
      <lib-loading-shimmer [height]="inputShimmerHeight" [width]="'100%'" />
    </div>
    <div class="grid-cell postal-code-cell d-flex flex-column gap-2">
      <lib-loading-shimmer [height]="labelShimmerHeight" [width]="'7rem'" />
      <lib-loading-shimmer [height]="inputShimmerHeight" [width]="'100%'" />
    </div>
  </div>
</ng-template>
